import { ImageCarousel } from '@shared-components/ImageCarousel/ImageCarousel';
import { WholesaleImageCarousel } from '@shared-components/ImageCarousel/WholesaleImageCarousel';

import { FALLBACK_IMAGE } from '../Gallery.constants';
import type { SlideshowGalleryProps } from '../Gallery.entity';

import styles from './SlideshowGallery.module.css';

const SlideshowGallery = ({
  images,
  slideshowGalleryStrings,
  comingSoonSlot,
  currentClickImgIndex,
  carouselProps,
  isInspectionReport,
  isZoomEnabled,
  tenant,
}: SlideshowGalleryProps) => {
  const totalImgs = images.length;
  const size = tenant === 'purchasePro' ? 'pdpPurchaseProSlideshow' : 'largest';
  const displayedImages = totalImgs ? images : [FALLBACK_IMAGE];

  return (
    <div
      className={styles.container}
      data-inspection-report={isInspectionReport}
      data-test-id="slideshow-gallery"
    >
      {tenant === 'purchasePro' ? (
        <WholesaleImageCarousel
          strings={slideshowGalleryStrings}
          images={images}
          positionIndex={currentClickImgIndex}
          shouldShowDotCarousel={false}
          index={0}
          size={size}
          carouselProps={carouselProps}
          isZoomEnabled={isZoomEnabled}
          isInspectionReport={isInspectionReport}
        />
      ) : (
        <ImageCarousel
          strings={slideshowGalleryStrings}
          images={displayedImages}
          comingSoonSlot={comingSoonSlot}
          positionIndex={currentClickImgIndex}
          shouldShowDotCarousel={false}
          index={0}
          size={size}
          carouselProps={carouselProps}
          tenant={tenant}
        />
      )}
    </div>
  );
};

export default SlideshowGallery;
